export const text =
  '【活动回顾 & PPT 下载】TiDB 社区活动沈阳站，聚焦民生，TiDB 加速政企数字化转型！活动帖评论区分享活动收获，参与社区新款周边抽奖！ ';
export const link = 'https://asktug.com/t/topic/1043168'
